<template>
  <div class="apps">
    <EntityList
      v-bind:endpoint="'api/apps'"
      v-bind:filters="''"
      v-bind:entity="appEntity"
      v-bind:editAllowedFields="['name', 'code']"
      v-bind:notDisplayedFields="[]"
      v-bind:addLinkToDetails="true"
      v-bind:detailsRouterName="'appdetails'"
      v-bind:defaultValues="{}"
      v-bind:title="'Apps'"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import AppEntity from '../store/entity/App';

export default {
  name: 'apps',
  components: { EntityList },
  data() {
    return {
      appEntity: AppEntity,
    };
  },
};
</script>

<style scoped>

</style>
